import { ShiftAttributes } from '@/types'
import { UpdateShiftMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditShiftQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { useEffect, useState } from 'react'
import { Query as TableQuery } from './table_query'
import { Button } from '@/components/base/button'
import { DeleteDialog } from '@/components/delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Inline as Error } from '@/components/error'

type Shift = EditShiftQuery['shifts']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateShiftMutation, ShiftAttributes, EditShiftQuery, Shift>({
    id,
    initializer: shift => ({
      eventId: shift.event.id,
      userId: shift.user?.id,
      start: shift.start || (new Date).toISOString(),
      finish: shift.finish || (new Date).toISOString(),
      rateCents: shift.rateCents || 0,
      shiftRoleId: shift.shiftRole?.id
    }),
    query: EditQuery,
    queryKey: 'shifts',
    mutation: UpdateMutation,
    resultKey: 'updateShift',
    refetchQueries: [TableQuery]
  })

  const [showDelete, setShowDelete] = useState(false)

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  const onDelete = () => {
    setShowDelete(false)
    onSuccess()
  }

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Person', field: 'userId', type: 'user' }) }
        { formBuilder.buildField({ name: 'Role', field: 'shiftRoleId', type: 'shift-role' }) }
        <div className="grid grid-cols-2 gap-6">
          { formBuilder.buildField({ name: 'Start', field: 'start', type: 'datetime' }) }
          { formBuilder.buildField({ name: 'Finish', field: 'finish', type: 'datetime' }) }
        </div>
        { formBuilder.buildField({ name: 'Rate', field: 'rateCents', type: 'currency' })}
        <div className="flex flex-row justify-between">
          <Button color="red" onClick={() => setShowDelete(true) }>Delete</Button>
          { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
        </div>
        <DeleteDialog
          id={id}
          mutation={DeleteMutation}
          open={showDelete}
          refetchQueries={[TableQuery]}
          setOpen={setShowDelete}
          onSuccess={onDelete}
        />
      </div>
    </>
  )
}
